import { render, staticRenderFns } from "./AllocateProfiles.vue?vue&type=template&id=08325a9e&"
import script from "./AllocateProfiles.vue?vue&type=script&lang=js&"
export * from "./AllocateProfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports